import { store } from 'store/store'

export const UPDATE_MESSAGE = "message/update";
export const RESET_MESSAGE = "message/reset";

const initialState = {
  message: { 
    doDisplay: false, 
    header: "", 
    text: "", 
    color: "blue" 
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MESSAGE:
      setTimeout(() => {
        store.dispatch({
          type: RESET_MESSAGE
        })
      }, 10000);
      return {
        ...state,
        message: action.message
      };
    case RESET_MESSAGE:
      return {
        ...state,
        message: {}
      };
    default:
      return state;
  }
};

